module.exports = __webpack_public_path__ + "98522fb3003c6a900752cf8c9c61e578.png";